import React from 'react';
// import {Link} from 'react-router-dom';

// import GlobalConst from '../../../common/global-const';

// import {Container, Row, Col, Button} from 'react-bootstrap';

// import {ReactComponent as ImgAccessDenied} from '../../../assets/images/svg/access-denied.svg';

// import * as Icon from 'react-icons/all';

// import './AccessDenied.scss';

const AccessDenied = () => {

    // document.documentElement.setAttribute('data-access', 'public')
    // document.documentElement.setAttribute('data-page', 'access-denied')

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <div id="pageAccessDenied">
            {/*<Container fluid="lg">*/}
            {/*    <Row className="h-100">*/}
            {/*        <Col className="px-5 pb-4 banner">*/}
            {/*            /!*<ImgAccessDenied className="mw-100"/>*!/*/}
            {/*        </Col>*/}
            {/*        <Col xs="12" className="d-flex justify-content-center align-items-center flex-column text-center">*/}
            {/*            <div className="h2 mb-2 font-fa text-primary">خطای دسترسی</div>*/}
            {/*            <p>شما مجوز دسترسی به این صفحه را ندارید.</p>*/}
            {/*            <p className="text-muted">به حساب کاربری {GlobalConst.appTitleShort} وارد شوید.</p>*/}
            {/*            <Button as={Link} to="/login" variant="outline-secondary mt-3">ورود*/}
            {/*                به {GlobalConst.appTitleShort}<Icon.FiArrowLeft size={24} className="ms-2"/></Button>*/}
            {/*        </Col>*/}
            {/*    </Row>*/}
            {/*</Container>*/}
        </div>
    )
}

export default AccessDenied;
